var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	809: () => (loadStrictVersionCheckFallback("default", "@source-web-es/themes", [1,3,1,4], () => (Promise.all([__webpack_require__.e("vendors-node_modules_source-web-es_themes_dist_index_mjs"), __webpack_require__.e("webpack_sharing_consume_default_styled-components_styled-components")]).then(() => (() => (__webpack_require__(4165))))))),
	5919: () => (loadStrictVersionCheckFallback("default", "@source-web-es/base-props", [1,1,0,5], () => (__webpack_require__.e("node_modules_source-web-es_base-props_dist_index_mjs").then(() => (() => (__webpack_require__(4904))))))),
	4292: () => (loadSingletonVersionCheckFallback("default", "styled-components", [1,6,0,7], () => (__webpack_require__.e("vendors-node_modules_styled-components_dist_styled-components_browser_esm_js").then(() => (() => (__webpack_require__(4715))))))),
	3644: () => (loadStrictVersionCheckFallback("default", "@source-web-es/mixins", [1,3,1,3], () => (__webpack_require__.e("node_modules_source-web-es_mixins_dist_index_mjs-_0a2d1").then(() => (() => (__webpack_require__(3972))))))),
	171: () => (loadStrictVersionCheckFallback("default", "@source-web-es/interaction", [1,4,0,0], () => (__webpack_require__.e("node_modules_source-web-es_interaction_dist_index_mjs-_21fc1").then(() => (() => (__webpack_require__(186))))))),
	8467: () => (loadStrictVersionCheckFallback("default", "@source-web-es/loading-spinner", [1,3,1,2], () => (__webpack_require__.e("node_modules_source-web-es_loading-spinner_dist_index_mjs-_19c11").then(() => (() => (__webpack_require__(7114))))))),
	4116: () => (loadStrictVersionCheckFallback("default", "@source-web-es/icon", [1,3,2,2], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_source-web-es_base-props_source-web-es_base-props"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_number-badge_source-web-es_number-badge"), __webpack_require__.e("node_modules_source-web-es_icon_dist_index_mjs-_3d241")]).then(() => (() => (__webpack_require__(2855))))))),
	6973: () => (loadStrictVersionCheckFallback("default", "@source-web-es/number-badge", [1,3,1,2], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes"), __webpack_require__.e("node_modules_source-web-es_number-badge_dist_index_mjs-_fe091")]).then(() => (() => (__webpack_require__(4593))))))),
	9987: () => (loadStrictVersionCheckFallback("default", "@source-web-es/button", [1,4,0,0], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_base-props_source-web-es_base-props"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_interaction_source-web-es_interaction"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_loading-spinner_source-web-es_loading-spinner"), __webpack_require__.e("node_modules_source-web-es_button_dist_index_mjs-_570f1")]).then(() => (() => (__webpack_require__(3010))))))),
	1227: () => (loadStrictVersionCheckFallback("default", "@source-web-es/styles", [1,3,1,2], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_styled-components_styled-components"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_mixins_source-web-es_mixins"), __webpack_require__.e("node_modules_source-web-es_styles_dist_index_mjs")]).then(() => (() => (__webpack_require__(8984))))))),
	8205: () => (loadStrictVersionCheckFallback("default", "@source-web-es/icon-rulesets", [1,1,1,2], () => (__webpack_require__.e("node_modules_source-web-es_icon-rulesets_dist_index_mjs").then(() => (() => (__webpack_require__(2757))))))),
	5699: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-util", [1,1,0,0], () => (__webpack_require__.e("node_modules_vfes_react-mfe-util_dist_index_js").then(() => (() => (__webpack_require__(3872))))))),
	9783: () => (loadSingletonVersionCheckFallback("default", "react-dom", [1,18,2,0], () => (() => (__webpack_require__(961))))),
	5941: () => (loadSingletonVersionCheckFallback("default", "i18next", [1,23,7,8], () => (__webpack_require__.e("vendors-node_modules_i18next_dist_esm_i18next_js").then(() => (() => (__webpack_require__(2635))))))),
	8493: () => (loadSingletonVersionCheckFallback("default", "react-i18next", [4,13,5,0], () => (__webpack_require__.e("vendors-node_modules_react-i18next_dist_es_index_js").then(() => (() => (__webpack_require__(2389))))))),
	6115: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-events", [1,1,0,0], () => (__webpack_require__.e("node_modules_vfes_react-mfe-events_dist_index_js-_90721").then(() => (() => (__webpack_require__(5931))))))),
	2707: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-content", [4,1,1,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_vfes_react-mfe-content_dist_index_js"), __webpack_require__.e("webpack_sharing_consume_default_i18next_i18next-webpack_sharing_consume_default_react-i18next-172de6")]).then(() => (() => (__webpack_require__(1399))))))),
	2983: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-state", [1,1,0,0], () => (__webpack_require__.e("node_modules_vfes_react-mfe-state_dist_index_js-_e18e1").then(() => (() => (__webpack_require__(3851))))))),
	8180: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-api", [1,1,0,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_vfes_react-mfe-api_dist_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(3445))))))),
	6849: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-transform", [1,1,0,0], () => (__webpack_require__.e("node_modules_vfes_react-mfe-transform_dist_index_js-_b4351").then(() => (() => (__webpack_require__(3302))))))),
	9054: () => (loadStrictVersionCheckFallback("default", "opencv-react-ts", [3,0,0,11], () => (__webpack_require__.e("node_modules_opencv-react-ts_dist_index_modern_js").then(() => (() => (__webpack_require__(4940))))))),
	1727: () => (loadStrictVersionCheckFallback("default", "@reduxjs/toolkit", [1,2,2,0], () => (__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_modern_mjs").then(() => (() => (__webpack_require__(9360))))))),
	1654: () => (loadStrictVersionCheckFallback("default", "react-hooks-full-screen", [3,0,0,1], () => (__webpack_require__.e("node_modules_react-hooks-full-screen_es_index_js").then(() => (() => (__webpack_require__(7181))))))),
	6356: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-library", [1,1,0,3], () => (Promise.all([__webpack_require__.e("vendors-node_modules_vfes_react-mfe-library_dist_components_index_js"), __webpack_require__.e("webpack_sharing_consume_default_vfes_react-mfe-util_vfes_react-mfe-util"), __webpack_require__.e("webpack_sharing_consume_default_vfes_react-mfe-api_vfes_react-mfe-api-webpack_sharing_consume-31404b")]).then(() => (() => (__webpack_require__(1699))))))),
	6918: () => (loadStrictVersionCheckFallback("default", "@source-web-es/theme-ws10", [1,3,1,3], () => (Promise.all([__webpack_require__.e("vendors-node_modules_source-web-es_theme-ws10_dist_index_mjs"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_icon-rulesets_source-web-es_icon-rulesets")]).then(() => (() => (__webpack_require__(6649))))))),
	5124: () => (loadStrictVersionCheckFallback("default", "@source-web-es/language-packs", [1,1,0,6], () => (__webpack_require__.e("node_modules_source-web-es_language-packs_dist_index_mjs").then(() => (() => (__webpack_require__(259))))))),
	9966: () => (loadStrictVersionCheckFallback("default", "@source-web-es/icon-button", [1,4,0,1], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_base-props_source-web-es_base-props"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_interaction_source-web-es_interaction"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_loading-spinner_source-web-es_loading-spinner"), __webpack_require__.e("node_modules_source-web-es_icon-button_dist_index_mjs-_ed0c1")]).then(() => (() => (__webpack_require__(1686))))))),
	7995: () => (loadStrictVersionCheckFallback("default", "react-redux", [1,9,1,0], () => (__webpack_require__.e("vendors-node_modules_react-redux_dist_react-redux_mjs").then(() => (() => (__webpack_require__(1468))))))),
	7178: () => (loadStrictVersionCheckFallback("default", "@source-web-es/heading", [4,3,1,2], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_base-props_source-web-es_base-props"), __webpack_require__.e("node_modules_source-web-es_heading_dist_index_mjs-_66091")]).then(() => (() => (__webpack_require__(696))))))),
	6204: () => (loadStrictVersionCheckFallback("default", "@source-web-es/small-button", [1,4,0,1], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_base-props_source-web-es_base-props"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_interaction_source-web-es_interaction"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_loading-spinner_source-web-es_loading-spinner"), __webpack_require__.e("node_modules_source-web-es_small-button_dist_index_mjs-_07091")]).then(() => (() => (__webpack_require__(3332))))))),
	448: () => (loadStrictVersionCheckFallback("default", "@source-web-es/link", [1,4,0,1], () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_base-props_source-web-es_base-props"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_interaction_source-web-es_interaction"), __webpack_require__.e("node_modules_source-web-es_link_dist_index_mjs-_ed231")]).then(() => (() => (__webpack_require__(8114))))))),
	2831: () => (loadStrictVersionCheckFallback("default", "pure-react-carousel", [1,1,30,1], () => (__webpack_require__.e("vendors-node_modules_pure-react-carousel_dist_index_es_js").then(() => (() => (__webpack_require__(3529))))))),
	3030: () => (loadStrictVersionCheckFallback("default", "lottie-react", [1,2,4,0], () => (__webpack_require__.e("vendors-node_modules_lottie-react_build_index_umd_js").then(() => (() => (__webpack_require__(8051))))))),
	873: () => (loadStrictVersionCheckFallback("default", "@vfes/react-mfe-config", [2,0,3,0], () => (__webpack_require__.e("node_modules_vfes_react-mfe-config_dist_index_js-_69f21").then(() => (() => (__webpack_require__(8084))))))),
	2769: () => (loadSingletonVersionCheckFallback("default", "react", [1,18,2,0], () => (() => (__webpack_require__(6540)))))
};
var initialConsumes = [2769];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"webpack_sharing_consume_default_source-web-es_themes_source-web-es_themes": [
		809
	],
	"webpack_sharing_consume_default_source-web-es_base-props_source-web-es_base-props": [
		5919
	],
	"webpack_sharing_consume_default_styled-components_styled-components": [
		4292
	],
	"webpack_sharing_consume_default_source-web-es_mixins_source-web-es_mixins": [
		3644
	],
	"webpack_sharing_consume_default_source-web-es_interaction_source-web-es_interaction": [
		171
	],
	"webpack_sharing_consume_default_source-web-es_loading-spinner_source-web-es_loading-spinner": [
		8467
	],
	"webpack_sharing_consume_default_source-web-es_icon_source-web-es_icon": [
		4116
	],
	"webpack_sharing_consume_default_source-web-es_number-badge_source-web-es_number-badge": [
		6973
	],
	"webpack_sharing_consume_default_source-web-es_button_source-web-es_button": [
		9987
	],
	"webpack_sharing_consume_default_source-web-es_styles_source-web-es_styles": [
		1227
	],
	"webpack_sharing_consume_default_source-web-es_icon-rulesets_source-web-es_icon-rulesets": [
		8205
	],
	"webpack_sharing_consume_default_vfes_react-mfe-util_vfes_react-mfe-util": [
		5699
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		9783
	],
	"webpack_sharing_consume_default_i18next_i18next-webpack_sharing_consume_default_react-i18next-172de6": [
		5941,
		8493
	],
	"webpack_sharing_consume_default_vfes_react-mfe-api_vfes_react-mfe-api-webpack_sharing_consume-31404b": [
		6115,
		2707,
		2983,
		8180,
		6849
	],
	"src_components_layout_utils_ts-src_containers_idcheck-form_idcheck-form_tsx-src_containers_id-a98cf8": [
		9054,
		1727,
		1654,
		6356,
		6918,
		5124,
		9966
	],
	"src_containers_app_app_tsx-src_hooks_useTranslation_ts": [
		7995,
		7178,
		6204,
		448,
		2831,
		3030,
		873
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}